import React, { useEffect, useState } from 'react';
import styles from './notes.module.sass';

export function NoteAvatar({ fullName, isMine, ...props }) {
  const [initials, setInitials] = useState('');
  useEffect(() => {
    if (!fullName) return () => {};
    const splittedName = fullName.split(' ');
    if (splittedName.length === 0) {
      setInitials('N/A');
    } else if (splittedName.length === 1) {
      const firstName = splittedName[0];
      setInitials(firstName[0]);
    } else if (splittedName.length === 2) {
      const firstName = splittedName[0];
      const lastName = splittedName[1];
      setInitials(firstName[0] + lastName[0]);
    }
  }, [fullName]);

  return (
    <div
      style={{
        background: isMine ? '#E0529C' : '#A8C1F8',
        ...(props.style || {}),
      }}
      className={styles['note-avatar-container']}
    >
      <span
        style={{
          ...((props.style &&
            'fontSize' in props.style && { fontSize: props.style.fontSize }) ||
            {}),
        }}
        className={styles['note-avatar-initials']}
      >
        {initials}
      </span>
    </div>
  );
}
